"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RealtimeNotification = void 0;
const constants_1 = require("./constants");
class RealtimeNotification {
    constructor(transport, handlers = []) {
        this.listenersConfig = [];
        this.handlers = [];
        this.transport = transport;
        this.handlers = handlers;
        this.initEvents();
    }
    initEvents() {
        if (!this.transport) {
            return;
        }
        this.transport.on(constants_1.EVENT_NAME, (message) => {
            const { type } = message;
            this.listenersConfig.forEach((listenerConfig) => {
                if (listenerConfig.type === type) {
                    listenerConfig.listener.call(null, message);
                }
            });
            this.handlers.forEach((handler) => {
                if (handler.type === type) {
                    handler.execute(message);
                }
            });
        });
    }
    isConnected() {
        return this.transport.isConnected();
    }
    reconnect(data) {
        if (!this.transport) {
            return;
        }
        this.transport.reconnect(data);
        this.initEvents();
    }
    addListener(type, listener) {
        this.listenersConfig.push({
            type,
            listener,
        });
        return () => {
            this.removeListener(listener);
        };
    }
    removeListener(listener) {
        this.listenersConfig = this.listenersConfig.filter((listenerConfig) => listener !== listenerConfig.listener);
    }
}
exports.RealtimeNotification = RealtimeNotification;
